import InputGroup from './input-group';

export default InputGroup;
